import { render, staticRenderFns } from "./CustomerMediaTeaser.vue?vue&type=template&id=262de41b&scoped=true"
import script from "./CustomerMediaTeaser.vue?vue&type=script&lang=js"
export * from "./CustomerMediaTeaser.vue?vue&type=script&lang=js"
import style0 from "./CustomerMediaTeaser.vue?vue&type=style&index=0&id=262de41b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262de41b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductVideoPreview: require('/app/components/ProductVideoPreview.vue').default})
